import { render, staticRenderFns } from "./TabChecklistProtocol.vue?vue&type=template&id=6e62c9e6&scoped=true&"
import script from "./TabChecklistProtocol.vue?vue&type=script&lang=js&"
export * from "./TabChecklistProtocol.vue?vue&type=script&lang=js&"
import style0 from "./TabChecklistProtocol.vue?vue&type=style&index=0&id=6e62c9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62c9e6",
  null
  
)

export default component.exports